// Shades from color 1's were generated with https://coolors.co/
export const COLOR_PALETTE = [
  /*
  Used to have the same colors 
  in the same order for all charts
  */
  "#95C087", // 0 green
  "#EDC45C", // 0 yellow
  "#88D8E5", // 0 sky_blue
  "#F1995E", // 0 orange
  "#E76D64", // 0 red
  "#4790CC", // 0 blue
  "#C665B8", // 0 magenta
  "#8A7AB0", // 0 purple
  "#FF9AC4", // 0 pink
  "#48E7DF", // 0 turquoise
  "#7eb26d", // 1 green
  "#eab838", // 1 yellow
  "#6ed0e0", // 1 sky_blue
  "#ef833b", // 1 orange
  "#e24d42", // 1 red
  "#1f78c1", // 1 blue
  "#ba43a9", // 1 magenta
  "#705d9f", // 1 purple
  "#FF84B7", // 1 pink
  "#20e2d8", // 1 turquoise
  "#68925A", // 2 green
  "#C0972E", // 2 yellow
  "#5BABB8", // 2 sky_blue
  "#C46C31", // 2 orange
  "#B94037", // 2 red
  "#1A639E", // 2 blue
  "#99378B", // 2 magenta
  "#5C4D83", // 2 purple
  "#D16D96", // 2 pink
  "#1BB9B1", // 2 turquoise
  "#517246", // 3 green
  "#957624", // 3 yellow
  "#46858F", // 3 sky_blue
  "#995426", // 3 orange
  "#90322A", // 3 red
  "#144D7B", // 3 blue
  "#772B6C", // 3 magenta
  "#483C66", // 3 purple
  "#A35475", // 3 pink
  "#15908A", // 3 turquoise
];

export const COLOR_PALETTE_DARKER = [
  /*
  Used for chart hover circle color
  To be visible when overlayed on COLOR_PALETTE colors

  Darker colors are +1,
  e.g. '1 green' uses '2 green' as its darker color
  */
  "#7eb26d", // 1 green
  "#eab838", // 1 yellow
  "#6ed0e0", // 1 sky_blue
  "#ef833b", // 1 orange
  "#e24d42", // 1 red
  "#1f78c1", // 1 blue
  "#ba43a9", // 1 magenta
  "#705d9f", // 1 purple
  "#FF84B7", // 1 pink
  "#20e2d8", // 1 turquoise
  "#68925A", // 2 green
  "#C0972E", // 2 yellow
  "#5BABB8", // 2 sky_blue
  "#C46C31", // 2 orange
  "#B94037", // 2 red
  "#1A639E", // 2 blue
  "#99378B", // 2 magenta
  "#5C4D83", // 2 purple
  "#D16D96", // 2 pink
  "#1BB9B1", // 2 turquoise
  "#517246", // 3 green
  "#957624", // 3 yellow
  "#46858F", // 3 sky_blue
  "#995426", // 3 orange
  "#90322A", // 3 red
  "#144D7B", // 3 blue
  "#772B6C", // 3 magenta
  "#483C66", // 3 purple
  "#A35475", // 3 pink
  "#15908A", // 3 turquoise
  "#435E3A", // 4 green
  "#7A611E", // 4 yellow
  "#3A6D76", // 4 sky_blue
  "#7E4520", // 4 orange
  "#762923", // 4 red
  "#114065", // 4 blue
  "#622459", // 4 magenta
  "#3B3254", // 4 purple
  "#864560", // 4 pink
  "#127671", // 4 turquoise
];
